<template lang="pug">
.bmw(v-if="showMenu && (bookings.length > 0 || (newBooking && newBooking.endDate))")
  template(v-if="bookings.length > 1 && mode !== 'new'")
    .booking-menu-wrapper(:style="{ left: pos.x + 'px', top: pos.y + 'px' }")
      .status-selection(
        v-for="booking, idx in bookings",
        @mouseenter="switchMenu(idx)"
        @mousedown.stop=""
        @mouseup.stop="switchMenu(idx)"
        :class="{selected: idx === nestedIdx}")
        .status-color(:style="{'backgroundColor': getColorCodeFromBooking(booking)}")
        .status-inner {{ getNameFromBooking(booking) }}
    .booking-menu-wrapper(:style="{ left: 240 + pos.x + 'px', top: pos.y + 'px' }")
      .status-selection(
        v-for="item, idx in nestedModeData",
        @mousedown.stop=""
        @mouseup.stop="triggerAction(item.action)",
        :class="{danger: item.danger}")
        .status-icon(v-if="item.icon")
          b-icon(:icon="item.icon")
        .status-color(v-else :style="{'backgroundColor': item.uuid ? getColorFromUUID(item.uuid) : item.colorCode}")
        .status-inner {{ item.name }}
  template(v-else)
    .booking-menu-wrapper(:style="{ left: pos.x + 'px', top: pos.y + 'px' }")
      .status-selection(
        v-for="item in menuData[mode]",
        @mousedown.stop=""
        @mouseup.stop="triggerAction(item.action)",
        :class="{danger: item.danger}")
        .status-icon(v-if="item.icon")
          b-icon(:icon="item.icon")
        .status-color(v-else :style="{'backgroundColor': item.uuid ? getColorFromUUID(item.uuid) : item.colorCode}")
        .status-inner {{ item.name }}
</template>

<script>

import { DateTime } from 'luxon';

const templateOpen = {
  name: "Bearbeiten",
  action: "openBooking",
  icon: "pencil",
}

const templatePrintOffer = {
  name: "Angebot drucken",
  action: "printOffer",
  icon: "printer",
}

const templateResendOffer = {
  name: "Angebot per E-Mail",
  action: "resendOffer",
  icon: "at",
}

const templateSendOffer = {
  name: "Angebot erstellen",
  action: "sendOffer",
  icon: "tag-outline",
}

const templatePrintContract = {
  name: "Mietvertrag drucken",
  action: "printContract",
  icon: "printer",
}

const templateResendContract = {
  name: "Mietvertrag per E-Mail",
  action: "resendContract",
  icon: "at",
}

const templatePrintCancelInvoice = {
  name: "Stornorechnung drucken",
  action: "printCancelInvoice",
  icon: "printer",
}

const templateResendCancelInvoice = {
  name: "Stornorechnung per E-Mail",
  action: "resendCancelInvoice",
  icon: "at",
}

const templateSendContract = {
  name: "Mietvertrag erstellen",
  action: "sendContract",
  icon: "file-document-outline",
}

const templateDelete = {
  name: "Löschen",
  action: "deleteBooking",
  icon: "delete-forever-outline",
  danger: true
}

const templateContractBack = {
  name: "Mietvertrag zurück",
  action: "contractBack",
  icon: "check-all",
}

const templateConvertToOption = {
  name: "In Option wandeln",
  action: "convertToOption",
  icon: "creation",
}

const templateCancel = {
  name: "Stornieren",
  action: "sendCancel",
  icon: "file-cancel-outline",
  danger: true
}

const templateCancelInvoice = {
  name: "Stornierungsrechnung",
  action: "sendCancelInvoice",
  icon: "file-cancel-outline",
  danger: true
}

const templatePayment = {
  name: "Neue Zahlung",
  action: "savePayment",
  icon: "credit-card-outline"
}

export default {
  props: {
    pos: {
      type: Object,
    },
    showMenu: {
      type: Boolean,
    },
    bookings: {
      type: Array,
    },
    newBooking: {
      type: Object,
    },
    mode: {
      type: String,
      default: "new",
    },
    settings: {
      type: Object,
      default() {
        return {}
      }
    }
  },
  data() {
    return {
      nestedIdx: 0,
      nestedMode: 'STATUS_BOOKING_INTERNET',
      showSendOfferModal: false,
      showSendContractModal: false,
      menuData: {
        new: [
          {
            name: "Neues Angebot",
            uuid: "STATUS_BOOKING_OFFER",
            action: "STATUS_BOOKING_OFFER",
          },
          {
            name: "Neue Buchung",
            uuid: "STATUS_CONTRACT_SENT",
            action: "STATUS_CONTRACT_SENT",
          },
          // {
          //   name: "Neue Eigentümerbuchung",
          //   uuid: "STATUS_BOOKING_OWNER",
          //   action: "STATUS_BOOKING_OWNER",
          // },
          {
            name: "Neue Eigenbelegung",
            uuid: "STATUS_BOOKING_PERSONAL",
            action: "STATUS_BOOKING_PERSONAL",
          },
          {
            name: "Neue Option",
            uuid: "STATUS_BOOKING_OPTION",
            action: "STATUS_BOOKING_OPTION",
          },
          {
            name: "Zeitraum sperren",
            uuid: "STATUS_BOOKING_BLOCKED",
            action: "STATUS_BOOKING_BLOCKED",
          },
        ],
        STATUS_BOOKING_INTERNET: {
          templateOpen,
          templateSendOffer,
          templateSendContract,
          templateDelete
        },
        STATUS_BOOKING_OFFER: {
          templateOpen,
          templateSendContract,
          templatePrintOffer,
          templateResendOffer,
          templateConvertToOption,
          templateDelete
        },
        STATUS_BOOKING_OPTION: {
          templateOpen,
          templateSendOffer,
          templateSendContract,
          templateDelete
        },
        STATUS_BOOKING_OWNER: {
          templateOpen,
          // templateSendOffer,
          templateSendContract,
          templateDelete
        },
        STATUS_BOOKING_PERSONAL: [
          templateOpen,
          templateDelete
        ],
        STATUS_BOOKING_BLOCKED: [
          templateOpen,
          templateDelete
        ],
        STATUS_CONTRACT_SENT: [
          templateOpen,
          templatePayment,
          templateContractBack,
          templatePrintContract,
          templateResendContract,
          templateDelete
        ],
        STATUS_CONTRACT_RECEIVED: this.settings.canDeleteAllBookings ? [
          templateOpen,
          templatePayment,
          templatePrintContract,
          templateResendContract,
          templateCancel,
          templateDelete
        ] : 
        [
          templateOpen,
          templatePayment,
          templatePrintContract,
          templateResendContract,
          templateCancel
        ],
        STATUS_BOOKING_CANCELED: this.settings.canDeleteAllBookings ? [
          templateOpen,
          templatePayment,
          templateCancelInvoice,
          templateDelete
        ] :
        [
          templateOpen,
          templatePayment,
          templateCancelInvoice
        ],
        STATUS_BOOKING_CANCELED_FINAL: this.settings.canDeleteAllBookings ? [
          templateOpen,
          templatePayment,
          templatePrintCancelInvoice,
          templateResendCancelInvoice,
          templateCancelInvoice,
          templateDelete
        ] :
        [
          templateOpen,
          templatePayment,
          templatePrintCancelInvoice,
          templateResendCancelInvoice,
          templateCancelInvoice
        ]
      },
    };
  },
  computed: {
    bookingStatus() {
      return this.$store.state.bookingStatus.all;
    },
    nestedModeData() {
      return this.menuData[this.nestedMode];
    }
  },
  methods: {
    switchMenu(idx) {
      this.nestedIdx = idx;
      this.$store.dispatch("rentObjectBookings/findOne", {id: this.bookings[idx].id});
      const status = this.bookingStatus.find(b => b.id === this.bookings[idx].bookingStatusId);
      this.nestedMode = status.uuid;
    },
    getColorCodeFromBooking(booking) {
      const status = this.bookingStatus.find(b => b.id === booking.bookingStatusId);
      return status.colorCode;
    },
    getNameFromBooking(booking) {
      const status = this.bookingStatus.find(b => b.id === booking.bookingStatusId);
      
      let modText = "";
      if (status.uuid === 'STATUS_BOOKING_PERSONAL') {
        modText = `EB`;
      } else if (status.uuid === 'STATUS_BOOKING_BLOCKED') {
        modText = `${booking.comment}`;
      } else if (status.uuid === 'STATUS_BOOKING_INTERNET') {
        modText = `${booking.customer.firstName ? booking.customer.firstName : ''} ${booking.customer.lastName}`;
      } else if (status.uuid === 'STATUS_BOOKING_OFFER') {
        modText = `#${booking.offers[booking.offers.length-1].id} ${booking.customer.firstName ? booking.customer.firstName : ''} ${booking.customer.lastName}`;
      } else if (['STATUS_CONTRACT_SENT', 'STATUS_CONTRACT_RECEIVED'].includes(status.uuid)) {
        modText = `#${booking.parentContractId} ${booking.customer.firstName ? booking.customer.firstName : ''} ${booking.customer.lastName}`;
      } else {
        modText = `${booking.customer.firstName ? booking.customer.firstName : ''} ${booking.customer.lastName}`;
      }
      return modText;
    },
    getColorFromUUID(uuid) {
      const status = this.bookingStatus.find((b) => b.uuid === uuid);
      return status.colorCode;
    },
    async triggerAction(action) {
      if (this.bookings && this.bookings[this.nestedIdx]) {
        this.$route.query.jumpDate = DateTime.fromISO(this.bookings[this.nestedIdx].startDate).toHTTP();
        this.$route.query.jumpObjectId = this.bookings[this.nestedIdx].rentObject.id;
      }

      if (action === "openBooking") {
        this.$emit("close");
        this.$router.push("/booking/" + this.bookings[this.nestedIdx].id);
      } else if (action === 'sendContract') {
        this.$emit("sendContract", this.bookings[this.nestedIdx]);
        this.$emit("close");
      } else if (action === 'printCancelInvoice') {
        const newFile = await this.$store.dispatch('cancelInvoices/getAttachement', {id: this.bookings[this.nestedIdx].cancelInvoices[this.bookings[this.nestedIdx].cancelInvoices.length - 1].id});
        const file = new Blob([newFile], { type: 'application/pdf' });
        const fileURL = URL.createObjectURL(file);
        window.open(fileURL);
        this.$emit("close");
      } else if (action === 'printContract') {
        const newFile = await this.$store.dispatch('contracts/getAttachement', {id: this.bookings[this.nestedIdx].parentContract.contracts[this.bookings[this.nestedIdx].parentContract.contracts.length - 1].id});
        const file = new Blob([newFile], { type: 'application/pdf' });
        const fileURL = URL.createObjectURL(file);
        window.open(fileURL);
        this.$emit("close");
      } else if (action === 'printOffer') {
        const newFile = await this.$store.dispatch('offers/getAttachement', {id: this.bookings[this.nestedIdx].offers[this.bookings[this.nestedIdx].offers.length - 1].id});
        const file = new Blob([newFile], { type: 'application/pdf' });
        const fileURL = URL.createObjectURL(file);
        window.open(fileURL);
        this.$emit("close");
      } else if (action === 'resendCancelInvoice') {
        this.$emit("resendCancelInvoice", this.bookings[this.nestedIdx]);
        this.$emit("close");
      } else if (action === 'resendContract') {
        this.$emit("resendContract", this.bookings[this.nestedIdx]);
        this.$emit("close");
      } else if (action === 'sendOffer') {
        this.$emit("sendOffer", this.bookings[this.nestedIdx]);
        this.$emit("close");
      } else if (action === 'resendOffer') {
        this.$emit("resendOffer", this.bookings[this.nestedIdx]);
        this.$emit("close");
      } else if (action === 'savePayment') {
        this.$emit("savePayment", this.bookings[this.nestedIdx]);
        this.$emit("close");
      } else if (action === "contractBack") {
        this.$emit("contractBack", this.bookings[this.nestedIdx]);
        this.$emit("close");
      } else if (action === "sendCancel") {
        this.$emit("sendCancel", this.bookings[this.nestedIdx]);
        this.$emit("close");
      } else if (action === "sendCancelInvoice") {
        this.$emit("sendCancelInvoice", this.bookings[this.nestedIdx]);
        this.$emit("close");
      } else if (action === "convertToOption") {
        const status = this.bookingStatus.find((b) => b.uuid === 'STATUS_BOOKING_OPTION');
        await this.$store.dispatch('rentObjectBookings/updateBookingStatus', {id: this.bookings[this.nestedIdx].id, bookingStatusId: status.id});
        this.$emit("refreshInbox");
        this.$emit("close");
      } else if (action === "deleteBooking") {
        this.$emit("close");
        this.$buefy.dialog.confirm({
          title: "Vorgang löschen",
          message: `Sind Sie sicher, dass Sie diesen Vorgang #${this.bookings[this.nestedIdx].id} löschen möchten? Diese Aktion kann nicht rückgängig gemacht werden.`,
          confirmText: `#${this.bookings[this.nestedIdx].id} jetzt löschen`,
          cancelText: "Abbrechen",
          type: "is-danger",
          hasIcon: true,
          onConfirm: async () => {
            try {
              this.$emit("close");
              const loadingComponent = this.$buefy.loading.open();
              await this.$store.dispatch("rentObjectBookings/delete", {id: this.bookings[this.nestedIdx].id});
              this.$emit("refreshInbox");
              loadingComponent.close();
            } catch (e) {
              this.$store.dispatch(
                "common/showError",
                "Vorgang konnte nicht gelöscht werden."
              );
            }
          },
        });
      } else if (action === "STATUS_BOOKING_OFFER") {
        this.$emit("close");
        this.$emit("addOffer", {...this.newBooking, startDate: this.newBooking.startDate.startOf('day').set({ hour: 15 }).toJSDate(), endDate: this.newBooking.endDate.startOf('day').set({ hour: 10 }).toJSDate()});
      } else {
        this.$emit("close");
        this.$router.push(
          `/booking/?status=${action}&rent-object-id=${
            this.newBooking.rentObjectId
          }&start=${this.newBooking.startDate.toHTTP()}&end=${this.newBooking.endDate.toHTTP()}`
        );
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.booking-menu-wrapper {
  position: absolute;
  width: 240px;
  height: auto;
  background-color: white;
  border-radius: 3px;
  z-index: 99;
  box-shadow: 0 10px 15px -3px rgba(53, 38, 38, 0.4),
    0 4px 6px -2px rgba(0, 0, 0, 0.2);
  // padding: $xs-space;
  transform: translate(-50%, 4px);
}

.status-selection {
  display: flex;
  justify-content: flex-start;
  align-items: center;
  font-size: 13px;
  font-weight: 500;
  cursor: pointer;
  user-select: none;
  text-align: left;
  color: black;
  font-weight: 500;
  &.danger {
    color: $danger;
  }
  .status-icon {
    padding: 0 0 0 $sm-space;
  }
  .status-color {
    display: inline-block;
    height: 35px;
    width: 10px;
  }
  .status-inner {
    display: inline-block;
    white-space: nowrap;
    padding: $xs-space $sm-space;
    display: flex;
    justify-content: center;
    align-items: center;
  }
  &:hover {
    box-shadow: $shadow-md;
    background-color: $light;
  }
  &.selected {
    box-shadow: $shadow-md;
    background-color: $light;
  }
  &.inactive {
    background-color: $lightgray !important;
    opacity: 0.48;
  }
}
</style>